import React from 'react';
import { certificates } from '../mock';
import { Award } from 'lucide-react';

const Certificates = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <section className="bg-gradient-to-br from-[#001F3F] to-[#003366] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center mb-6">
            <Award size={48} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">Sertifikalarımız</h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto text-center">
            Goo More ürünlerimizle uluslararası kalite standartları ve sertifikalarımızla güvenilir hizmet sunuyoruz.
          </p>
        </div>
      </section>

      {/* Certificates Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {certificates.map((cert) => (
              <div 
                key={cert.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105"
              >
                <div className="aspect-[2/3] overflow-hidden bg-gradient-to-br from-[#001F3F]/5 to-[#003366]/10">
                  <img 
                    src={cert.image} 
                    alt={`Sertifika ${cert.id}`}
                    className="w-full h-full object-contain hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-[#001F3F] mb-6">Kalite ve Güven</h2>
          <p className="text-lg text-gray-700 leading-relaxed">
             Goo More olarak, tüm ürünlerimizde uluslararası kalite standartlarına uygun üretim yapmaktayız. 
            Sertifikalarımız, ürünlerimizin kalitesinin ve güvenilirliğinin kanıtıdır.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Certificates;